import Vue from 'vue';

Vue.directive('overlay', {

});
